function showOverlay(highlightId) {
    const overlay = document.querySelector('.overlay');
    const overlayContent = document.querySelector('.overlay-content');
    if (!overlay || !overlayContent) return;
    overlayContent.dataset.highlightId = highlightId;
    overlayContent.scrollTop = 0;

    // Remove all children except the close button
    Array.from(overlayContent.children).forEach((child) => {
        if (!child.classList.contains('close-btn')) {
            overlayContent.removeChild(child);
        }
    });

    // Reset dark mode and small class
    overlayContent.classList.remove('dark', 'small', 'scroll');

    // Find and clone the highlight element
    const highlightElement = document.getElementById(highlightId);
    if (highlightElement) {
        const clonedContent = highlightElement.cloneNode(true);
        clonedContent.style.display = 'block';

        if (highlightId === 'tech-specs-module') {
            const pills = Array.from(clonedContent.querySelectorAll('[data-tech-spec-index]'));
            const panels = Array.from(clonedContent.querySelectorAll('[data-tech-spec-panel]'));
            pills.forEach((pill) => {
                const idx = Number(pill.dataset.techSpecIndex);
                const hasUrl = window.currentProductDiagrams && !!window.currentProductDiagrams[idx];
                if (!hasUrl) {
                    pill.parentNode.removeChild(pill);
                    const panel = panels.find(p => Number(p.dataset.techSpecPanel) === idx);
                    if (panel) {
                        panel.parentNode.removeChild(panel);
                    }
                }
            });
        }

        if (highlightElement.classList.contains('dark')) {
            overlayContent.classList.add('dark');
        }

        if (highlightElement.classList.contains('small')) {
            overlayContent.classList.add('small');
        }

        if (highlightElement.classList.contains('scroll')) {
            overlayContent.classList.add('scroll');
        }

        overlayContent.appendChild(clonedContent);
        const highlightNav = clonedContent.querySelector('.hl-editorial__nav');
        if (highlightNav) {
            highlightNav.hidden = document.querySelectorAll('.overlay-content-container .hl-editorial-module').length < 2;
        }
        syncPillSelectors(clonedContent);

        if (clonedContent.id === 'tech-specs-module') {
            const activeIndex = Number(
                clonedContent.querySelector('[data-tech-spec-index].is-active')?.dataset.techSpecIndex || 0
            );
            setTechSpecsDiagramState(clonedContent, activeIndex);
        }
    }

    // Show overlay and prevent scroll
    overlay.style.display = 'flex';
    document.body.classList.add('scroll-lock');

    // Fade in
    setTimeout(() => {
        overlay.style.opacity = '1';
        overlayContent.classList.add('active');
        syncPillSelectors(overlayContent);
        requestAnimationFrame(() => syncPillSelectors(overlayContent));
    }, 10);
}

function navigateHighlight(direction) {
    const overlayContent = document.querySelector('.overlay-content');
    if (!overlayContent) return;
    const modules = Array.from(document.querySelectorAll('.overlay-content-container .hl-editorial-module'));
    const currentIndex = modules.findIndex(module => module.id === overlayContent.dataset.highlightId);
    if (currentIndex < 0 || modules.length < 2) return;
    const nextIndex = (currentIndex + direction + modules.length) % modules.length;
    showOverlay(modules[nextIndex].id);
    overlayContent.querySelector(direction < 0 ? '[aria-label="Previous highlight"]' : '[aria-label="Next highlight"]')?.focus({ preventScroll: true });
}

function syncPillSelectors(root = document) {
    root.querySelectorAll('.pill-selector').forEach((selectorRoot) => {
        const pills = Array.from(selectorRoot.querySelectorAll('.pill-selector__button'));
        const activePill = selectorRoot.querySelector('.pill-selector__button.is-active') || pills[0];
        if (activePill) {
            window.WSPillSelector?.sync(selectorRoot, activePill);
        }
    });
}

let techSpecA11ySeed = 0;

function ensureTechSpecsA11y(moduleRoot) {
    const selectorRoot = moduleRoot.querySelector('.pill-selector');
    const track = selectorRoot?.querySelector('.pill-selector__track');
    const pills = Array.from(moduleRoot.querySelectorAll('[data-tech-spec-index]'));
    const panels = Array.from(moduleRoot.querySelectorAll('[data-tech-spec-panel]'));
    if (!selectorRoot || !pills.length || !panels.length) return { selectorRoot, pills, panels };

    const prefix = moduleRoot.dataset.techSpecA11yPrefix || `tech-spec-${++techSpecA11ySeed}`;
    moduleRoot.dataset.techSpecA11yPrefix = prefix;

    track?.setAttribute('role', 'tablist');
    track?.setAttribute('aria-label', 'Tech spec diagrams');

    pills.forEach((pill, i) => {
        const tabId = `${prefix}-tab-${i}`;
        const panelId = `${prefix}-panel-${i}`;
        pill.id = tabId;
        pill.setAttribute('role', 'tab');
        pill.setAttribute('aria-controls', panelId);
    });

    panels.forEach((panel, i) => {
        const panelId = `${prefix}-panel-${i}`;
        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', pills[i].id);
    });

    return { selectorRoot, pills, panels };
}

function setTechSpecsDiagramState(moduleRoot, index) {
    const { selectorRoot, pills, panels } = ensureTechSpecsA11y(moduleRoot);
    if (!selectorRoot || !pills.length || !panels.length) return;

    const targetPillIndex = pills.findIndex(p => Number(p.dataset.techSpecIndex) === index);
    const safeIndex = targetPillIndex >= 0 ? targetPillIndex : 0;

    if (window.WSPillSelector?.setActive) {
        window.WSPillSelector.setActive(selectorRoot, pills, safeIndex, {
            onChange: (_, i, isActive) => {
                const panel = panels[i];
                if (!panel) return;
                panel.classList.toggle('is-active', isActive);
                panel.hidden = !isActive;
            },
        });
        return;
    }

    pills.forEach((pill, i) => {
        const isActive = i === safeIndex;
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
        pill.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    panels.forEach((panel, i) => {
        const isActive = i === safeIndex;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
    });

    window.WSPillSelector?.sync(selectorRoot, pills[safeIndex]);
}

function closeOverlay() {
    const overlay = document.querySelector('.overlay');
    const overlayContent = document.querySelector('.overlay-content');
    if (!overlay || !overlayContent) return;

    overlay.style.opacity = '0';
    overlayContent.classList.remove('active');
    document.body.classList.remove('scroll-lock');

    setTimeout(() => {
        overlay.style.display = 'none';
    }, 500);
}

document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector('.overlay') || !document.querySelector('.overlay-content')) return;
    document.querySelectorAll('.grid-item:not(.two-rectangles):not(.two-rectangles-vertical), .small-rectangle').forEach((item) => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();
            const highlightId = item.getAttribute('highlight-id');
            showOverlay(highlightId, false);
        });
    });

    document.querySelector('.overlay').addEventListener('click', (e) => {
        if (e.target.classList.contains('overlay')) {
            closeOverlay();
        }
    });

    document.querySelector('.close-btn').addEventListener('click', closeOverlay);

    document.querySelector('.overlay-content').addEventListener('click', (e) => {
        const pill = e.target.closest('[data-tech-spec-index]');
        if (!pill) return;

        const moduleRoot = pill.closest('#tech-specs-module');
        if (!moduleRoot) return;

        const index = Number(pill.dataset.techSpecIndex || 0);
        setTechSpecsDiagramState(moduleRoot, index);
    });

    document.querySelector('.overlay-content').addEventListener('keydown', (e) => {
        const pill = e.target.closest('[data-tech-spec-index]');
        if (!pill) return;

        const moduleRoot = pill.closest('#tech-specs-module');
        if (!moduleRoot) return;

        const pills = Array.from(moduleRoot.querySelectorAll('[data-tech-spec-index]'));
        const currentIndex = pills.indexOf(pill);
        if (currentIndex < 0) return;

        let nextIndex = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') nextIndex = (currentIndex + 1) % pills.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') nextIndex = (currentIndex - 1 + pills.length) % pills.length;
        if (e.key === 'Home') nextIndex = 0;
        if (e.key === 'End') nextIndex = pills.length - 1;
        if (nextIndex === null) return;

        e.preventDefault();
        setTechSpecsDiagramState(moduleRoot, Number(pills[nextIndex].dataset.techSpecIndex));
        pills[nextIndex]?.focus();
    });

    const templateTechSpecsModule = document.getElementById('tech-specs-module');
    if (templateTechSpecsModule) {
        const activeIndex = Number(
            templateTechSpecsModule.querySelector('[data-tech-spec-index].is-active')?.dataset.techSpecIndex || 0
        );
        setTechSpecsDiagramState(templateTechSpecsModule, activeIndex);
    }

    window.addEventListener('resize', () => {
        syncPillSelectors(document.querySelector('.overlay-content'));
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closeOverlay();
        }
    });
});
